export default __webpack_public_path__ + "static/media/credpallogo.5f5b89f6.svg";